import LIST_BID_MIRRORS from '@/brain/bid-mirror/ListBidMirrors'
import SAVE_BID_MIRROR from '@/brain/bid-mirror/SaveBidMirror'
import GET_BID_MIRROR_BY_EVENT from '@/brain/bid-mirror/GetBidMirrorByEvent'

const state = {
  bidMirrors: []
}

const getters = {
  BID_MIRRORS: state => state.bidMirrors
}

const mutations = {
  BID_MIRRORS: (state, bidMIrrors) => { state.bidMirrors = bidMIrrors }
}

const actions = {
  LIST_BID_MIRRORS,
  SAVE_BID_MIRROR,
  GET_BID_MIRROR_BY_EVENT
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/view/bid-mirror/state/index.js